import { createContext, useContext, useState, ReactNode } from "react";

interface AgeVerificationContextType {
  isAgeVerified: boolean;
  setAgeVerified: (verified: boolean) => void;
}

const AgeVerificationContext = createContext<AgeVerificationContextType | undefined>(undefined);

export const AgeVerificationProvider = ({ children }: { children: ReactNode }) => {
  const [isAgeVerified, setIsAgeVerified] = useState(() => {
    // Check sessionStorage for existing verification
    if (typeof window !== "undefined") {
      return sessionStorage.getItem("ageVerified") === "true";
    }
    return false;
  });

  const setAgeVerified = (verified: boolean) => {
    setIsAgeVerified(verified);
    if (verified) {
      sessionStorage.setItem("ageVerified", "true");
    } else {
      sessionStorage.removeItem("ageVerified");
    }
  };

  return (
    <AgeVerificationContext.Provider value={{ isAgeVerified, setAgeVerified }}>
      {children}
    </AgeVerificationContext.Provider>
  );
};

export const useAgeVerification = () => {
  const context = useContext(AgeVerificationContext);
  if (!context) {
    throw new Error("useAgeVerification must be used within AgeVerificationProvider");
  }
  return context;
};
